import { render, staticRenderFns } from "./mainDesktop.vue?vue&type=template&id=2f994b80"
import script from "./mainDesktop.vue?vue&type=script&lang=js"
export * from "./mainDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports